const DropDownListComponent = ({ id, name, valueList, onChangeHandler }) => {
  return (
    <>
      <select
        id={id}
        name={name}
        onChange={onChangeHandler ? onChangeHandler : ""}
      >
        <option value="all">{`All`}</option>
        {valueList.map((value, idx) => (
          <option key={`${value.value}-${idx}`} value={value.value}>
            {value.content}
          </option>
        ))}
      </select>
    </>
  );
};

export { DropDownListComponent };
